/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { Props } from '../types';

type CognitoRegistrationProps = {
  'label-email': string;
  'label-username': string;
  'label-password': string;
  'label-password-confirm': string;
  'label-submit': string;
  'label-optin-first': string;
  'label-optin-second': string;
  'label-optin-notice': string;
  'label-unmatched-passwords': string;
  'label-confirm-registration': string;
  'url-registration-success': string;
  'label-invalid-parameter-exception': string;
  'label-username-exists-exception': string;
};

// eslint-disable-next-line max-len
export const CognitoRegistration = ({ blok, slot }: Props<CognitoRegistrationProps>): JSX.Element => {
  const URL = blok.confirmation_page.story?.url ?? blok.confirmation_page.url;
  return (React.createElement('roche-registration', {
    'label-username': blok.user_label,
    'label-email': blok.email_label,
    'label-password': blok.password_label,
    'label-password-confirm': blok.confirm_password_label,
    'label-submit': blok.submit_label,
    'label-optin-first': blok.opt_in_text_2,
    'label-optin-second': blok.opt_in_text_3,
    'label-optin-notice': blok.opt_in_text_1,
    'label-unmatched-passwords': blok.unmatched_passwords_text,
    'label-confirm-registration': blok.confirmation_text,
    'url-registration-success': `/${URL}`,
    'label-invalid-parameter-exception': blok.label_invalid_parameter_exception,
    'label-username-exists-exception': blok.label_username_exists_exception,
    role: blok.roles,
    slot,
  }));
};
